var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { allComposables } from "../composables";
import { observable, action } from "mobx";
/**
 * Piper class - deals with pipes and managing them.
 */
/* istanbul ignore next */
export class Piper {
    constructor(composables) {
        this.pipeline = this.compilePipeline(composables);
    }
    /**
     * executePipeline - runs a dataset through all the elements of the pipe
     * @param {Event[]} data data to manipulate
     * @returns {Event[]} manipulated data
     *
     * TODO: decide if to work with reference data or to force .slice() on the input array.
     */
    executePipeline(data) {
        return this.pipeline.reduce((a, b) => a[b.method](b.cb), data);
    }
    /**
     * compilePipeline - creates array of the different methods that need to run in the provided sequence
     * @param {STRING[]} composables names of the entities that are going to be piped
     * @returns {ComposedValue[]}
     */
    compilePipeline(composables) {
        return this.pipeline = composables
            .map(x => allComposables[x])
            .filter(x => typeof x !== "undefined");
    }
    /**
     * swap - removes one entity and puts another in it's place if both exist.
     * @param {STRING} toSwap name of entity you want to swap
     * @param {STRING} swapWith name of entity to swap with
     * @returns {VOID}
     */
    swap(toSwap, swapWith) {
        let i = this.pipeline.findIndex(x => x.name === toSwap);
        if (i > -1 && typeof allComposables[swapWith] !== "undefined") {
            this.pipeline.splice(i, 1, allComposables[swapWith]);
        }
    }
    /**
     * remove - removes element from the pipe.
     * @param {STRING} toRemove name of entity to remove
     * @returns {VOID}
     */
    remove(toRemove) {
        let i = this.pipeline.findIndex(x => x.name === toRemove);
        if (i > -1) {
            this.pipeline.splice(i, 1);
        }
    }
    /**
     * add - adds entity on a specified index or at the end of the array. If it already exists it does nothing.
     * @param {STRING} toAdd name of entity to add
     * @param {NUMBER} index optional index where to put the new element. Defaults to append at the end.
     */
    add(toAdd, index) {
        let i = this.pipeline.findIndex(x => x.name === toAdd);
        if (i === -1 && typeof allComposables[toAdd] !== "undefined") {
            this.pipeline.splice(index || this.pipeline.length, 0, allComposables[toAdd]);
        }
    }
    /**
     * append - alis for .add()
     * @param {STRING} toAdd name of entity to add at the end of the array.
     */
    append(toAdd) {
        this.add(toAdd);
    }
    /**
     * appendAll - .add() to all elements of the array
     * @param {STRING[]} toAdd
     */
    appendAll(toAdd) {
        toAdd.forEach((elementToAdd) => this.add(elementToAdd));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Piper.prototype, "pipeline", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Piper.prototype, "executePipeline", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Piper.prototype, "compilePipeline", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], Piper.prototype, "swap", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Piper.prototype, "remove", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], Piper.prototype, "add", null);
//# sourceMappingURL=piper.js.map